import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pupNoticeExpired } from '../../redux/pupSlice';
import './PupNoticeStrip.css';

// How long each toast stays up before it self-expires.
const NOTICE_TTL_MS = 6000;

// One toast row. Its own component so the expiry timer is a per-toast hook.
const PupNoticeToast = ({ roomId, notice }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const elapsed = Date.now() - (notice.receivedAt || Date.now());
    const t = setTimeout(
      () => dispatch(pupNoticeExpired({ roomId, id: notice.id })),
      Math.max(0, NOTICE_TTL_MS - elapsed)
    );
    return () => clearTimeout(t);
  }, [dispatch, roomId, notice.id, notice.receivedAt]);
  return (
    <div
      className={`pup-notice pup-notice-${notice.kind}`}
      onClick={() => dispatch(pupNoticeExpired({ roomId, id: notice.id }))}
    >
      {notice.text}
    </div>
  );
};

// Transient Power-Up announcements for one table (a Stream Sniper guess hit/missed, a
// Negotiation vote failed, a play was countered) — stacked toasts near the top of the felt,
// each self-expiring (or click-to-dismiss). Renders nothing when the room has no notices.
const PupNoticeStrip = ({ roomId }) => {
  const notices = useSelector((state) => state.pup.notices[roomId]);
  if (!notices || notices.length === 0) return null;
  return (
    <div className="pup-notice-strip">
      {notices.map((n) => (
        <PupNoticeToast key={n.id} roomId={roomId} notice={n} />
      ))}
    </div>
  );
};

export default PupNoticeStrip;
